<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  .am-photo-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    .am-photo {
      width: utils.in_rem(24px);
      height: utils.in_rem(24px);
      border-radius: 50%;
      display: inline-block;
      background-color: colors.get(interfaceWhite);
    }
  }
</style>

<script>
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store.js";
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { getDemoLink } from "../../../../api/requests.js";

  let { kind = "upgrade", license, size = "large" } = $props();

  const handleBookDemo = async () => {
    const currentUser = $userStore;
    const body = {
      email: currentUser.regularizedEmail,
      selectedModule: license,
      teamId: currentUser.teamId,
    };
    const response = await getDemoLink(body);
    if (response.url) window.open(response.url);
  };

  let amInfo = $derived($userStore?.accountManagerInfo);
  let buttonText = $derived(
    amInfo ? `Explore with ${amInfo.firstName}` : "Book a Demo"
  );
</script>

<Button {kind} {size} onclick={handleBookDemo}>
  <span class="am-photo-container">
    {#if amInfo}
      <img
        class="am-photo"
        src={amInfo.photo || "/assets/img/icons/user.png"}
        alt={amInfo.firstName}
      />
    {/if}
    <span>{buttonText}</span>
  </span>
</Button>
